import { BrowserRouter as Router, Route, Routes, useParams,  Navigate } from 'react-router-dom';
import Register from './features/auth/register';
import Login from './features/auth/login';
import { Component, useEffect, useState } from 'react';
import NavBar from './utilities/navbar';
import Cookies from 'js-cookie';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
// import { login } from './user';
import NotUser from './utilities/not-user';
import MainPage from './main';
import Details from './features/blacklist/details';
import Dashboard from './features/admin/dashboard';
import Payment from './features/admin/features/payment';
import NotPaid from './utilities/not-paid';
import Terms from './utilities/terms';
import AllUserEdit from './features/admin/features/allusers';
import UserEdit from './features/admin/features/user';
import BlacklistEdit from './features/admin/features/blacklist/blacklist';
import DetailEdit from './features/admin/features/blacklist/details';
import RepEdit from './features/admin/features/reps/representatives';
import DetailRepEdit from './features/admin/features/reps/details';
import UserList from './features/admin/features/allusers';
import { CircleLoader } from 'react-spinners';
import axios from 'axios';

const App = () => {
  const [removed, setRemoved] = useState(null);
  const [id, setID] = useState("");


    const userRemoved = async () => {
      const test_get_user_link = "http://localhost:3000/current/user/"
      const production_get_user_link = "https://apple-tree-server.vercel.app/current/user"
      const user_id = Cookies.get('token_id')

      await axios.post(production_get_user_link, {
          user_id
      })
      .then((res) => {
        
          if (res.data[0].removed == "false") {
              setRemoved(false)
          } else {
            setRemoved(true)
          }

      })
      .catch((err) => {
          console.log(err)
      })
  }
   
      const company = Cookies.get(`token_company`);
      const email = Cookies.get(`token_email`);
      const firstname = Cookies.get(`token_first_name`);
      const lastname = Cookies.get(`token_last_name`);
      const phone = Cookies.get(`token_phone`);
      const statusNow = Cookies.get(`token_status`);
      const admin = Cookies.get(`token_admin`)


      useEffect(() => {
        userRemoved();
        let tokenid = Cookies.get('token_id')
        setID(tokenid)
        return;
      }, []);
  
      if (!firstname || !lastname || !company || !email || !phone ||!admin) {
          return (
            <Router >
              <NavBar/>
                  <Routes>
                      <Route path="/" element={<NotUser/>}/>
                      <Route exact path="/login"  element={<Login/>}/>
                      <Route exact path="/register"  element={<Register/>}/>
                      <Route exact path='/terms' element = {<Terms/>}/>

                      <Route path="*" element={<Navigate to="/" />} />

                  </Routes>
            </Router>
          )
      }
  
  
      if (statusNow != 'Paid') {
          return (
            <Router >
            <NavBar/>
            <Routes>
                      <Route exact path="/login"  element={<Login/>}/>
                      <Route exact path="/register"  element={<Register/>}/>
                      <Route path="/" element={<NotPaid/>}/>
            <Route exact path='/terms' element = {<Terms/>}/>

                      <Route path="*" element={<Navigate to="/" />} />

                  </Routes>
              </Router>
          )
      }

      

      if (removed == null) {
          return (
          <Router >
              <NavBar/>

              <div>


                   
                  <div style={{height:"50vh"}} className="d-flex justify-content-center align-items-center ">
                  
                              <CircleLoader size={200} color="#cdc59a"/>
              </div>
              </div>
            </Router>
              
          )
      }

      if (removed) {
        return (
          <Router>
                <NavBar/>


              <p className='text-center'>

                You have been <span className='text-danger'>removed</span> 
              </p>
              <p className='text-center text-muted fs-6'>
                <Link href='/login' className='text-secondary'>Sign in</Link> or <br/> Email: luyanda@thepeople.co.za 
              </p>
              <Routes>
                <Route path='/register' element={<Register/>}/>
                <Route path='/login' element={<Login/>}/>
            <Route exact path='/terms' element = {<Terms/>}/>

                <Route path="*" element={<Navigate to="/" />} />
       
              </Routes>
          </Router>
        )

      }
      return (
        <div className='mb-5'>
          <Router >
          <NavBar/>
          <Routes>
            <Route path='/register' element={<Register/>}/>
            <Route path='/login' element={<Login/>}/>
            <Route exact path='/' element={<MainPage/>}/>
            <Route path='/blacklist/:reference' element={<Details/>}/>
            <Route path='/dashboard' element = {<Dashboard/>} />
            <Route path='/edit/payment' element = {<Payment/>} />
            <Route path='/not-paid'  element = {<NotPaid/>}/>
            <Route path='/terms' element = {<Terms/>}/>
            <Route path='/edit/users/all' element = {<AllUserEdit/>}/>
            <Route path='/edit/user' element = {<UserEdit/>}/>
            <Route path='/edit/blacklist' element = {<BlacklistEdit/>}/>
            <Route path='/edit/company' element = {<AllUserEdit/>}/>
            <Route path='/edit/blacklist/:reference' element={<DetailEdit/>}/>
            <Route path='/edit/representatives' element={<RepEdit/>}/>
            <Route path='/edit/representatives/:reference' element={<DetailRepEdit/>}/>
            <Route path='/company' element={<UserList/>}/>
            <Route path="*" element={<Navigate to="/" />} />



          </Routes>
          
        </Router>

        </div>
              );
    
    
  }


export default App;
